import React, { useState, useEffect } from "react";
import logo from "../../style/images/blue-logo-without-tagline.svg";
import FeedbackForm from "./FeedBackForm";
import {
  getFeedbackTags,
} from "../../services/RatingService";

type FeedbackTags = { title: string; type: string }[];

const Rating: React.FC = () => {
  const [feedbackTags, setFeedbackTags] = useState<FeedbackTags>([]);

  const buildTagData = (type: string, tags: string[]): FeedbackTags => {
    return tags.map((tag) => {
      return { title: tag, type };
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [tagsResponse] = await Promise.all([
          getFeedbackTags(),
        ]);

        if (tagsResponse?.status.success) {
          const { product, service } = tagsResponse.data;
          const allTags = [
            ...buildTagData("product", product),
            ...buildTagData("service", service),
          ];
          setFeedbackTags(allTags);
        }
      } catch (error) {
        console.error("Error fetching feedback data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="parent-container bg-white flex-grow">
      <div className="flex flex-col items-center">
        <div className="mb-6 rounded-md pt-[127px]">
          <img
            src={logo}
            alt="urban naps"
            style={{ width: "139px", height: "73px" }}
          />
        </div>
        <div className="text-2xl text-center text-customBlack font-semibold px-12">
          Thank you for using <br/> Urban Naps.
        </div>
        <div className="text-base text-customTextMildDarkGrey font-medium my-3">
          Don't forget to take your belongings
        </div>
      </div>
      <div className="flex flex-col items-center mt-10">
        <div className="text-base text-customTextDarkerBlue font-semibold my-3">
          Rate your experience
        </div>
        <FeedbackForm tags={feedbackTags} />
      </div>
    </div>
  );
};

export default Rating;
